import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ButtonTheme from "../ThemeButton/ThemeButton";
import Error from "../Error/Error";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';

export default function FormSelectOption({
  CloseEditMode,
  editItem,
  editMode,
  loadData,
}) {
  const [loading, setLoading] = useState(false);
  // const { enqueueSnackbar } = useSnackbar();
  let SelectOptionsListDDL = useSelector((state) => {
    return state.ddlReducer.SelectOptionsListDDL;
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    reset,
    isValid,
    getValues,
  } = useForm({
    defaultValues: editItem ? { ...editItem } : {},
  });
  const onSubmit = async (data) => {
    setLoading(true);
    let urlAction = "/createSelectOption";
    let text = "added";
    if (editMode == "edit") {
      urlAction = "/updateSelectOption";
      text = "updated";
    }
    await ApiService.post(urlAction, data)
      .then((data) => {
        setLoading(false);
        CloseEditMode();
        toast.success(text + "successfully")
        // enqueueSnackbar(text + "successfully", { variant: "success" });
        loadData();
      })
      .catch(({ data }) => {
        if (data.errors) {
          Object.entries(data.errors).forEach((value) => {
            setError(value[0], { message: value[1] });
          });
        }
        setLoading(false);
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}>
          <Grid item xs={4}>
            <Autocomplete
              disabled={editMode == "edit"}
              className=" w-100"
              disablePortal
              disableClearable={true}
              options={SelectOptionsListDDL.map((item) => {
                return {
                  label: item,
                  value: item,
                };
              })}
              defaultValue={getValues("SO_Code")}
              {...register("SO_Code", { required: "Code is required" })}
              onChange={(e, value) => setValue("SO_Code", value.value)}
              renderInput={(params) => (
                <TextField color="secondary" {...params} label="Code" />
              )}
            />
            {errors.SO_Code && <Error>{errors.SO_Code?.message}</Error>}
          </Grid>

          <Grid item xs={4}>
            <TextField
              disabled={editMode == "edit"}
              className="w-100"
              label="Value"
              {...register("SO_Value", { required: "Value is required" })}
            />
            {errors.SO_Value && <Error>{errors.SO_Value?.message}</Error>}
          </Grid>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              label="Description"
              {...register("SO_Desc", { required: "Description is required" })}
            />
            {errors.SO_Desc && <Error>{errors.SO_Desc?.message}</Error>}
          </Grid>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              label="Condition"
              {...register("SO_Condition")}
            />
            {errors.SO_Condition && (
              <Error>{errors.SO_Condition?.message}</Error>
            )}
          </Grid>
          <Grid item xs={4}>
            <TextField
              className="w-100"
              label="Sort"
              type="number"
              {...register("SO_Sort")}
            />
            {errors.SO_Sort && <Error>{errors.SO_Sort?.message}</Error>}
          </Grid>
          <Grid item xs={4} md={8}>
            <ButtonTheme
              type="submit"
              color="primary"
              // isSendToRequired &&
              disabled={isValid == true || loading}
              style={{
                width: "140px",
                textTransform: "capitalize",
              }}
            >
              Save
            </ButtonTheme>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
